module.exports = "../static/media/banner_short.64f93e85.png";